// extracted by mini-css-extract-plugin
module.exports = {"ModalButton":"appointments__DigitalAppointmentForm__ModalButton"};